export default __webpack_public_path__ + "static/media/result_not_found.7118b4d5.png";